import { defineComponent as _defineComponent } from 'vue'

export default /*#__PURE__*/_defineComponent({
  __name: 'Panel',
  props: {
    hasBorder: { type: Boolean },
    transparentBg: { type: Boolean }
  },
  emits: ["click"],
  setup(__props: any, { emit: emits }: { emit: ({
    (e: 'click', ev)
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
    hasBorder?: boolean,
    transparentBg?: boolean
}




return { __sfc: true,props, emits }
}

})